import GetStarted from "./GetStarted"
import HowItWorks from "./HowItWorks"
import Benefits from "./Benefits"
import OurPricing from "./OurPricing"

export { GetStarted, HowItWorks, Benefits, OurPricing }
